import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: "0px",
    left: "0px",
    zIndex: 5,
    backgroundColor: "#000000DD",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

export default function ProgressOverlay(props) {
  const classes = useStyles();
  if (props.completed > 0 && props.completed < 100) {
    return (
      <div className={classes.root}>
        <CircularProgress size={100} variant="static" value={props.completed} />
      </div>
    );
  } else {
    return "";
  }
}
